import WalletModal from "../modals/WalletModal";

const CtaSection = () => {
  return (
    <section className="overflow-hidden mb-16">
      <div className="container mx-auto px-4 relative pt-40 md:pb-40">
        <img
          className="absolute top-0 left-1/2 transform -translate-x-1/2"
          src="/assets/images/radial.png"
          alt="..."
        />
        <div className="relative z-10 container mx-auto px-4 mb-12">
          <div className="flex flex-wrap -m-6">
            <div className="w-full lg:w-1/2 p-6">
              <div className="lg:max-w-xl">
                <h2 className="mb-6 font-heading font-bold text-5xl sm:text-6xl md:text-7xl text-white">
                  Ready to Stake Your NFTs?
                </h2>
                <p className="mb-8 text-base text-white">
                  Join SoftStake today and start earning rewards on your digital
                  assets. It's simple, secure, and rewarding.
                </p>

                <div className="max-w-56">
                  <WalletModal title="Connect Wallet" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pl-4 lg:w-1/2 lg:absolute lg:bottom-0 lg:right-0">
          <img
            className="relative z-10 ml-auto transform hover:-translate-x-28 transition ease-in-out duration-500 rounded-xl"
            src="/assets/images/NFT-staking.jpg"
            alt="..."
          />
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
